/**
@ngdoc directive
@name multiselectInline

@description
tags combined with multiselect inside the dropdown
ngRequired for now NOT dynamic!

@usage

*/

(function() {
  'use strict';

var multiselectTerms = function($templateCache) {
    return {
        restrict: "EA",
        scope: true,
        bindToController: {
            label: '@',
            fieldName: "@",
            ngModel:"=",
            ngDisabled: "=",
            data:"&",
            ngRequired: "=?",
            maxDropdownHeight:'@',
            inline: '@'
        },
        controllerAs:'ctrl',
        replace: true,
        transclude: false,
        template: $templateCache.get("formWidget/multiselectTerms.html"),
        controller: function() {
                var _this = this;

                _this.isEmptyModel = function(){
                    var isEmpty = true;
                    angular.forEach(_this.ngModel, function(val){
                        if(val == true){
                            isEmpty = false;
                        }
                    });
                    return isEmpty;
                }

        }
    }
}
multiselectTerms.$inject = ['$templateCache'];
angular.module('app').directive('multiselectTerms', multiselectTerms);

}());

